import { restfulApiConfig } from './config';

export function dynamicLinksApi(data) {

  let childWindow = window.open('about:blank');
  console.log("restfulApiConfig.dynamicLinksDomain + data.url" , restfulApiConfig.dynamicLinksDomain + data.url);
  var params = {
    "longDynamicLink": restfulApiConfig.dynamicLinksDomain + data.url,
    'suffix': {
      'option': 'SHORT'
    }
  };
  window.fetch('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=' + restfulApiConfig.firebaseKey, {
    method:'post',
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8'
    },
    body: JSON.stringify(params)
  })
  .then( responce => responce.json() )
  .then( res => {
    let shareText = "https://twitter.com/intent/tweet?text=" + data.message + res.shortLink + "%20" + data.hashTag + data.username;

    if(window.open(shareText,"_blank")){
      childWindow.close();
      childWindow = null;
    }else{
      childWindow.location.href = shareText;
      childWindow = null;
    }
  });
}
// export default dynamicLinksApi;